import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';

import Typography from 'fuse-ui/components/Typography';
import { withStyles } from '@material-ui/core/styles';

const styles = theme => ( {
    subtitle: {
        marginBottom: 16
    },
    title: {
        textTransform: 'capitalize'
    },
} );

export const TabHeader = ( { classes, data, type } ) => {
    const totalCount = get( data, 'totalCount', 0 ).toLocaleString();
    const parentCount = get( data, 'parentDomains.totalCount', 0 ).toLocaleString();
    const subCount = get( data, 'subdomains.totalCount', 0 ).toLocaleString();

    return (
        <>
            <Typography classes={{ root: classes.title }} variant="h5">{type} domains</Typography>
            <Typography>
                {totalCount} Total {type} domains | {parentCount} Parent Domains | {subCount} Subdomains
            </Typography>
            <Typography classes={{ root: classes.subtitle }}>
                Message volume in the last 7 days
            </Typography>
        </>
    );
};

TabHeader.propTypes = {
    classes: PropTypes.object,
    data: PropTypes.shape( {
        parentDomains: PropTypes.shape( {
            totalCount: PropTypes.number
        } ),
        subdomains: PropTypes.shape( {
            totalCount: PropTypes.number
        } ),
        totalCount: PropTypes.number,
    } ),
    type: PropTypes.oneOf( ['claimed', 'discovered'] ).isRequired,
};


export default withStyles( styles )(  TabHeader );
